import React from 'react';
import { classNames } from '@shapeable/utils';
var cls = classNames('cookie-banner-features-list');
export var CookieBannerFeaturesListDefaultProps = {};
// -------- Child Component Props -------->
export var CookieBannerFeaturesList = function (props) {
  return React.createElement("ul", null, React.createElement("li", null, React.createElement("b", null, "Mapping Cookie:"), " enables the mapping feature (Mapbox)"), React.createElement("li", null, React.createElement("b", null, "Contact Form Cookie:"), " enables the form feature (Netlify)."));
};
CookieBannerFeaturesList.cls = cls;
CookieBannerFeaturesList.defaultProps = CookieBannerFeaturesListDefaultProps;